
'use strict';

angular.module('nfseApp')
    .factory('EscritorioContabil', function ($resource) {
        return $resource('api/escritorios-contabeis/:id', {}, {
            'query': {method: 'GET', isArray: true, url:'api/escritorios-contabeis'}
        });
    });
